import GroupPostDetailPageComments from "./GroupPostDetailPageComments";
import GroupPostDetailPageInfo from "./GroupPostDetailPageInfo";

export default [
    {
        name: 'GroupPostDetailPageComments',
        path: 'comments',
        component: GroupPostDetailPageComments,
        props: true, meta: {name: 'comments'}
    },
    {
        name: 'GroupPostDetailPageInfo',
        path: 'detail',
        component: GroupPostDetailPageInfo,
        props: true,
        meta: {name: 'info'}
    },
];